import { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import "../index.css";
import Select from "react-select";
import { getRequest } from "../../../Utils/Funciones/requester";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import EditButton from "../../../Utils/Botones/EditButton";
import moment from "moment";
import { Delete } from "@material-ui/icons";
import { checkApartadoFecha } from "../../../Utils/Funciones/checkApartado";
import { checkIfJExistAsignacionesFecha } from "../../../Utils/Funciones/checkIfJExistAsignaciones.js";
import { CircularProgress } from "@material-ui/core";

let grupoTimer;

export const AsignacionFechas = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [valueCiclo, setValueCiclo] = useState("");
  const [listSalon, setListSalon] = useState([]);
  const campusUser = useSelector((state) => state.campusName);
  const [data, setData] = useState([]);
  const [grupoValue, setGrupoValue] = useState("");
  const [materiaOptions, setMateriaOptions] = useState([]);
  const campusId = useSelector((state) => state.campusId);
  const [selectMateriaIsLoading, setSelectMateriaIsLoading] = useState(false);
  const [escuela, setEscuela] = useState("");
  const [direccion, setDireccion] = useState("");
  const [claveProfesor, setClaveProfesor] = useState("");
  const [asignado, setAsignado] = useState("");
  const [creado, setCreado] = useState("");
  const [creadoPor, setCreadoPor] = useState("");
  const [modificado, setModificado] = useState("");
  const [modificadoPor, setModificadoPor] = useState("");
  const [secludedClassrooms, setSecludedClassrooms] = useState([]);
  const [dataCustom, setDataCustom] = useState([]);
  const [tipoSalonSelectValue, setTipoSalonSelectValue] = useState([]);
  const [salonSelectValue, setSalonSelectValue] = useState([]);
  const [materia, setMateria] = useState({
    label: "",
    value: "",
  });
  const [tipoSalon, setSelectDataTipoSalon] = useState({
    label: "",
    value: "",
  });
  const [horasFinalesAnteriores, setHorasFinalesAnteriores] = useState([]);
  const [minutosFinalesAnteriores, setMinutosFinalesAnteriores] = useState([]);
  const [tipoSalonesPost, setTipoSalonesPost] = useState([]);
  const [maxValue, setMaxValue] = useState(30);
  const [indexSig, setIndexSig] = useState(null);
  const [indexAct, setIndexAct] = useState(null);
  const [defaultSalonSelectValue, setDefaultSalonSelectValue] = useState({});
  const [horariosState, setHorarios] = useState("");

  const defaultTipoSalonSelectValue = {
    label: ` - `,
    value: null,
  };
  const selectUpsStyles = {
    menuList: (base) => ({ ...base, maxHeight: "250px" }),
    menu: (base) => ({ ...base, zIndex: 999 }),
  };

  const getDefultSalon = async (campusId, enqueueSnackbar) => {
    try {
      const consulta = `/buscar?tipo=salon&valor=id:1,id_campus:${campusId}`;
      const response = await getRequest(consulta);
      if (response.s === "OK") {
        const defaultSalon = response.d.find((salon) => salon.nombre === " ");
        setDefaultSalonSelectValue({
          label: ` - `,
          value: defaultSalon.id_salon,
          name: " - ",
          capacidad: 0,
          delete: true,
        });
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } catch {
      setListSalon([]);
    }
  };

  const GetTipoSalon = async (enqueueSnackbar) => {
    const consulta = `/catalogo?id=24`;
    const response = await getRequest(consulta);
    let rowsP = "";
    if (response.s === "OK") {
      const array1 = [];
      const array2 = [];
      const arrayRows = [];
      response.d.elementos.forEach((e, i) => {
        const objp = Object.values(response.d.elementos[i]);
        array1[i] = objp;
      });

      const numRows_ = array1[0][0].length;

      for (let step = 0; step < numRows_; step++) {
        response.d.elementos.forEach((e, i) => {
          Object.values(response.d.elementos[i]).forEach((value) => {
            let numj = i - i + step;
            array2[i] = value[numj];
          });
        });
        arrayRows[step] = [...array2];
      }
      rowsP = arrayRows;
      const dataSelect = rowsP.map((e) => {
        const data_ = {
          label: `${e[1]} - ${e[2]}`,
          value: e[0],
        };
        return data_;
      });
      setSelectDataTipoSalon(dataSelect);
    } else {
      enqueueSnackbar(response.m, {
        variant: "error",
        autoHideDuration: null,
      });
    }
  };

  const getListSalonByTipo = async (
    event,
    i,
    element,
    isAll = false,
    getSalon = true,
    cleanSameDate = false
  ) => {
    const day = element[0]?.split("-");
    const fechaFila = element[0];
    const fechaInitial = `${day[2]}-${day[1]}-${day[0]}`;
    if (
      moment(moment().format("YYYY-MM-DD")).isAfter(
        `${day[2]}-${day[1]}-${day[0]}`
      )
    ) {
      return enqueueSnackbar(
        `La fecha de la asignación a modificar es menor a la actual`,
        { variant: "error", autoHideDuration: null }
      );
    }

    const condition = (filaIndex) =>
      cleanSameDate ? data[filaIndex][0] === fechaFila : filaIndex === i;

    setTipoSalonSelectValue((prev) =>
      prev.map((tipoSalon, index) => (condition(index) ? event : tipoSalon))
    );

    setSalonSelectValue((prev) =>
      prev.map((salon, index) => (condition(index) ? "" : salon))
    );

    setListSalon((prev) =>
      prev.map((salonList, index) => (condition(index) ? "" : salonList))
    );

    if (isAll) {
      setTipoSalonSelectValue((prev) => prev.map(() => event));
      setSalonSelectValue((prev) => prev.map(() => event));
      window.localStorage.setItem("asignacion", JSON.stringify([]));
      window.localStorage.setItem("dataTable", JSON.stringify([]));
    } else {
      if (getSalon) {
        let array =
          tipoSalonesPost.length !== 0 ? [...tipoSalonesPost] : dataCustom;
        array[i] = "";
        const horarios = `dias: ${element[1]} horas_inicio: ${element[2]} horas_fin: ${element[3]}`;
        const request = `/reportes/salones_ocupados?fecha_inicial=${fechaInitial}&fecha_final=${fechaInitial}&id_campus=${campusId}&horario=${horarios}&tipo_salon=${event.value}`;
        const consulta = `/buscar?tipo=salon&valor=id:${event.value},id_campus:${campusId}`;
        const response = await getRequest(consulta);
        const response2 = await getRequest(request);
        if (response.s === "OK") {
          if (!response.d || response.d.length === 0) {
            return enqueueSnackbar("No se ha encontrado ningún salón", {
              variant: "info",
            });
          }
          const busyClassrooms = response2?.d;
          const busyClassroomsInitial = [];
          const stringDay = element[1][0].toUpperCase();
          busyClassrooms?.forEach((responseItem) => {
            if (
              checkIfJExistAsignacionesFecha(
                responseItem.timeslots,
                element[2],
                element[3],
                element[1].toLowerCase() === "miercoles" ? "Mi" : stringDay
              )
            )
              busyClassroomsInitial.push(responseItem.id_classroom);
          });
          const infoJson = {
            day: element[1].slice(0, 3),
            initial: element[2],
            final: element[3],
          };
          const dataObjectInicio = Object.values(response.d)
            .map((e) => {
              if (!busyClassroomsInitial.includes(`${e.id_salon}`)) {
                const data_ = {
                  label: `${e.id_salon} - ${e.nombre}`,
                  value: e.id_salon,
                  name: e.nombre,
                  capacidad: e.capacidad,
                };
                return data_;
              }
              return null;
            })
            .map((e) => {
              if (!e) return null;

              const findClassroom = checkApartadoFecha(
                secludedClassrooms,
                e,
                infoJson
              );
              return findClassroom ? null : e;
            })
            .filter((item) => item !== null);
          if (dataObjectInicio.length === 0) {
            enqueueSnackbar(
              "Salones no disponibles en el horario seleccionado",
              { variant: "error", autoHideDuration: null }
            );
          } else {
            enqueueSnackbar(response.m, { variant: "success" });
            setListSalon((prev) =>
              prev.map((salon, index) => {
                if (i === index) return dataObjectInicio;
                return salon;
              })
            );
          }
        } else {
          enqueueSnackbar(response.m, {
            variant: "error",
            autoHideDuration: null,
          });
        }
      }
    }
  };

  const waitTime = 2000;
  const asyncSelectStyles = {
    container: (styles) => ({ ...styles, zIndex: 9 }),
  };

  async function searchMateria(id_campus, grupo, ciclo, enqueueSnackbar) {
    setSelectMateriaIsLoading(true);
    try {
      var options = [];
      const consulta = `/buscar?tipo=asignacion_profesor&valor=id_campus:${id_campus},grupo:${grupo},ciclo:${ciclo}`;
      const response = await getRequest(consulta);
      if (response.s === "OK") {
        if (!response.d || response.d.length === 0) {
          setMateriaOptions([]);
          setMateria("");
          enqueueSnackbar("Validar datos del grupo", { variant: "info" });
          return;
        }
        response.d.forEach((item, i) => {
          if (item.tipo_registro === "fecha determinada") {
            options.push({
              id: item.id_asignacion,
              value: i,
              label: `${item.clave_materia} - ${item.nombre_materia}`,
              id_person: item.id_person,
              tipo_registro: item.tipo_registro,
              escuela: item.escuela,
              direccion: item.direccion,
              nombre_profesor: item.nombre_profesor,
              start_date: item.start_date,
              end_date: item.end_date,
              asignados: item.asignados,
              horario: item.horario,
              salon_creado: item.salon_creado === null ? "" : item.salon_creado,
              salon_creado_por:
                item.salon_creado_por === null ? "" : item.salon_creado_por,
              salon_modificado:
                item.salon_modificado === null ? "" : item.salon_modificado,
              salon_modificado_por:
                item.salon_modificado_por === null
                  ? ""
                  : item.salon_modificado_por,
              ultima_sesion: item.ultima_sesion,
              primera_sesion: item.primera_sesion,
            });
          }
        });
        if (options.length === 0) {
          setMateriaOptions([]);
          enqueueSnackbar(
            "No se ha encontrado ninguna materia con fechas determinadas",
            { variant: "info" }
          );
          return;
        }
        let hash = {};
        options = options.filter((o) =>
          hash[o.label] ? false : (hash[o.label] = true)
        );
        setMateriaOptions(options);
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error, {
        variant: "error",
        autoHideDuration: null,
      });
    } finally {
      setSelectMateriaIsLoading(false);
    }
  }

  const handleGrupoValue = (e) => {
    setGrupoValue(e.target.value);
    setMateria("");
    setEscuela("");
    setDireccion("");
    setClaveProfesor("");
    setAsignado("");
    setData([]);
    setCreado("");
    setCreadoPor("");
    setModificado("");
    setModificadoPor("");
    setHorarios("");
  };

  function convertirFecha(fechaString) {
    var fechaSp = fechaString.split("-");
    var anio = new Date().getFullYear();
    if (fechaSp.length === 3) anio = fechaSp[2];

    var mes = fechaSp[1] - 1;
    var dia = fechaSp[0];

    return new Date(anio, mes, dia);
  }

  const handleMateria = async (e) => {
    setDataCustom([]);
    setData([]);
    setMateria(e);
    setEscuela(e.escuela);
    setDireccion(e.direccion);
    setClaveProfesor(e.nombre_profesor);
    setAsignado(e.asignados);
    let datos_salones_reservados = [];
    const defaultSelectSalones = [];
    var i = 0;
    const dayVariables = {};
    e.horario.forEach((item) => {
      const { dia, hora_inicio, hora_fin } = item;
      const combinedHours = [hora_inicio, hora_fin];
      if (!dayVariables[dia]) {
        dayVariables[dia] = combinedHours;
      } else {
        dayVariables[dia][0] =
          dayVariables[dia][0] > hora_inicio
            ? hora_inicio
            : dayVariables[dia][0];
        dayVariables[dia][1] =
          dayVariables[dia][1] < hora_fin ? hora_fin : dayVariables[dia][1];
      }
      datos_salones_reservados.push([
        item.fecha,
        item.dia,
        item.hora_inicio,
        item.hora_fin,
        item.tipo_salon === "default" ? "" : item.tipo_salon,
        item.salon,
        item.capacidad,
        item.id_schedule,
        "dissable",
        item.hora_inicio,
        item.hora_fin,
        i,
        item.salon_id,
      ]);
      i++;
      defaultSelectSalones.push("");
    });
    const scheduleData = [
      "lunes" in dayVariables ? dayVariables["lunes"].join("-") : "-",
      "martes" in dayVariables ? dayVariables["martes"].join("-") : "-",
      "miercoles" in dayVariables ? dayVariables["miercoles"].join("-") : "-",
      "jueves" in dayVariables ? dayVariables["jueves"].join("-") : "-",
      "viernes" in dayVariables ? dayVariables["viernes"].join("-") : "-",
      "sabado" in dayVariables ? dayVariables["sabado"].join("-") : "-",
      "domingo" in dayVariables ? dayVariables["domingo"].join("-") : "-",
    ];
    const days = [];
    const daysOfWeek = [
      "lunes",
      "martes",
      "miercoles",
      "jueves",
      "viernes",
      "sabado",
      "domingo",
    ];
    const initialHour = [];
    const finalHour = [];
    scheduleData.forEach((item, index) => {
      if (item === "-") return null;

      const time = item.split("-");
      initialHour.push(time[0]);
      finalHour.push(time[1]);
      days.push(daysOfWeek[index]);
    });
    const horarios = `dias: ${days.join(",")} horas_inicio: ${initialHour.join(
      ","
    )} horas_fin: ${finalHour.join(",")}`;
    datos_salones_reservados.sort(function (a, b) {
      return convertirFecha(a[0]) - convertirFecha(b[0]);
    });
    setHorarios(horarios);
    setTipoSalonSelectValue(defaultSelectSalones);
    setSalonSelectValue(defaultSelectSalones);
    setListSalon(defaultSelectSalones);
    try {
      setLoading(true);
      const fechas = e.horario.sort(
        (a, b) => convertirFecha(a?.fecha) - convertirFecha(b?.fecha)
      );
      const initialDateArray = fechas[0]?.fecha.split("-");
      const endDateArray = fechas[e.horario.length - 1]?.fecha.split("-");
      const initialDate = `${initialDateArray[2]}-${initialDateArray[1]}-${initialDateArray[0]}`;
      const endDate = `${endDateArray[2]}-${endDateArray[1]}-${endDateArray[0]}`;
      const request = `/salones/apartado?fi=${initialDate}&ff=${endDate}&id_campus=${campusId}&horario=${horarios}`;
      const response = await getRequest(request);
      if (response.s === "OK") {
        const fechas = datos_salones_reservados.map((item) => {
          return {
            capacidad: item[6],
            dia: item[1],
            hora_fin: item[3],
            hora_inicio: item[2],
            id_area: item[12],
            id_assignment: e.id,
            id_schedule: item[7],
            old_id_area: item[12],
            delete: false,
            default_salon: defaultSalonSelectValue.value,
          };
        });
        setDataCustom(fechas);
        setSecludedClassrooms(response.d);
        setData(datos_salones_reservados);
        setCreado(e.salon_creado);
        setCreadoPor(e.salon_creado_por);
        setModificado(e.salon_modificado);
        setModificadoPor(e.salon_modificado_por);
        setTipoSalonesPost(fechas);
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Ocurrio un error", {
        variant: "error",
        autoHideDuration: null,
      });
    } finally {
      setLoading(false);
    }
  };

  function handleHoraInicia(value, i, type) {
    const valueNew = parseInt(value);
    if (type === "i") {
      if (valueNew < 10) {
        let values = [...data];
        const data_map = values[i]?.with(
          2,
          `0${valueNew}:${values[i]?.[2].slice(-2)}`
        );
        values[i] = data_map;
        setData(values);
      } else {
        let values = [...data];
        const data_map = values[i]?.with(
          2,
          `${valueNew}:${values[i]?.[2].slice(-2)}`
        );
        values[i] = data_map;
        setData(values);
      }
    } else {
      if (valueNew < 10) {
        let values = [...data];
        const data_map = values[i]?.with(
          3,
          `0${valueNew}:${values[i]?.[3].slice(-2)}`
        );
        values[i] = data_map;
        setData(values);
      } else {
        let values = [...data];
        const data_map = values[i]?.with(
          3,
          `${valueNew}:${values[i]?.[3].slice(-2)}`
        );
        values[i] = data_map;
        setData(values);
      }
    }
  }

  function handleMinutosValue(value, i, type) {
    if (value === "00") return;

    const valueNew = parseInt(value);
    let array = tipoSalonesPost.map((element, index) => {
      if (index === i) return "";
      return element;
    });
    setTipoSalonesPost([...array]);
    if (type === "i") {
      if (valueNew < 10) {
        let values = [...data];
        const data_map = values[i]?.with(
          2,
          `${values[i]?.[2].substring(0, 2)}:0${valueNew}`
        );
        values[i] = data_map;
        setData(values);
      } else {
        let values = [...data];
        const data_map = values[i]?.with(
          2,
          `${values[i][2].substring(0, 2)}:${valueNew}`
        );
        values[i] = data_map;
        setData(values);
      }
    } else {
      if (valueNew < 10) {
        let values = [...data];
        const data_map = values[i]?.with(
          3,
          `${values[i]?.[3].substring(0, 3)}:0${valueNew}`
        );
        values[i] = data_map;
        setData(values);
      } else {
        let values = [...data];
        const data_map = values[i]?.with(
          3,
          `${values[i]?.[3].substring(0, 3)}${valueNew}`
        );
        values[i] = data_map;
        setData(values);
      }
    }
  }

  const handleChangeSalon = async (e, i, row, isAll = false) => {
    const day = row[0].split("-");
    if (moment().isAfter(`${day[2]}-${day[1]}-${day[0]}`)) return;

    const buildSalonObject = ({
      old_id_area,
      id_schedule,
      dia,
      hora_inicio,
      hora_fin,
      index,
      withLabel = false,
    }) => {
      const base = {
        old_id_area,
        id_schedule,
        id_area: e.value,
        capacidad: e.capacidad,
        dia,
        hora_inicio,
        hora_fin,
        id_assignment: materia.id,
        index,
        delete: e.delete ? true : false,
        default_salon: defaultSalonSelectValue.value,
      };

      return withLabel ? { ...base, value: e.value, label: e.label } : base;
    };

    let array, array_table;

    if (isAll) {
      setSalonSelectValue((prev) => prev.map(() => e));
      array = tipoSalonesPost.map((salon, index) =>
        buildSalonObject({
          old_id_area: data[index][12],
          id_schedule: salon.id_schedule,
          dia: salon.dia,
          hora_inicio: salon.hora_inicio,
          hora_fin: salon.hora_fin,
          index,
        })
      );

      array_table = tipoSalonesPost.map((salon, index) =>
        buildSalonObject({
          old_id_area: data[index][12],
          id_schedule: salon.id_schedule,
          dia: salon.dia,
          hora_inicio: salon.hora_inicio,
          hora_fin: salon.hora_fin,
          index,
          withLabel: true,
        })
      );
    } else {
      array = [...tipoSalonesPost];
      array_table = [...tipoSalonesPost];
      array[i] = buildSalonObject({
        old_id_area: data[i][12],
        id_schedule: data[i][7],
        dia: row[1],
        hora_inicio: row[2],
        hora_fin: row[3],
        index: i,
        withLabel: true,
      });

      array_table[i] = array[i];
      setSalonSelectValue((prev) =>
        prev.map((salon, index) => (index === i ? e : salon))
      );
    }

    const fechas = array.flatMap((item) => {
      if (!item) return [];
      const fecha_init = moment(item.hora_inicio, "HH:mm");
      const fecha_fin = moment(item.hora_fin, "HH:mm");
      const bloques = [];
      for (
        let hour = moment(fecha_init);
        hour.isBefore(fecha_fin);
        hour.add(30, "minutes")
      ) {
        const ffin = moment(hour).add(30, "minutes");
        bloques.push({
          id_schedule: item.id_schedule,
          id_area: item.id_area,
          capacidad: item.capacidad,
          dia: item.dia,
          hora_inicio: hour.format("HH:mm"),
          hora_fin: ffin.format("HH:mm"),
          id_assignment: item.id_assignment,
          old_id_area: item.old_id_area,
          delete: item.delete,
          default_salon: defaultSalonSelectValue.value,
        });
      }
      return bloques;
    });

    setTipoSalonesPost(array_table);

    ["asignacion", "dataTable", "tipo_modal"].forEach((key) =>
      window.localStorage.removeItem(key)
    );

    window.localStorage.setItem("asignacion", JSON.stringify(fechas));
    window.localStorage.setItem("tipo_modal", "fechas");
    window.localStorage.setItem("dataTable", JSON.stringify(data));
  };

  useEffect(() => {
    GetTipoSalon(enqueueSnackbar);
    getDefultSalon(campusId, enqueueSnackbar);
  }, [campusId, enqueueSnackbar]);

  useEffect(() => {
    clearTimeout(grupoTimer);
    setTipoSalonesPost([]);
    if (grupoValue.length >= 4) {
      grupoTimer = setTimeout(() => {
        searchMateria(campusId, grupoValue, valueCiclo, enqueueSnackbar);
      }, waitTime);
    }
  }, [grupoValue, campusId, valueCiclo, enqueueSnackbar]);

  let indexAnterior = -1;

  const updateDataAndSelects = (newData, fechaFila) => {
    newData.sort((a, b) => convertirFecha(a[0]) - convertirFecha(b[0]));
    setData(newData);

    const remap = (prev) => {
      const used = new Array(prev.length).fill(false);

      return newData.map((fila) => {
        if (fila[0] === fechaFila) return "";

        const oldIndex = data.findIndex(
          (d, idx) => d[0] === fila[0] && !used[idx]
        );

        if (oldIndex !== -1) {
          used[oldIndex] = true;
          return prev[oldIndex];
        }

        return "";
      });
    };

    setListSalon(remap);
    setTipoSalonSelectValue(remap);
    setSalonSelectValue(remap);
  };

  const handleAddFila = (key) => {
    const newData = [...data];
    const data_map = key.with(8, "notDissable").with(2, key[3]);
    const fechaFila = data_map[0];
    newData.push(data_map);
    updateDataAndSelects(newData, fechaFila);
  };

  const handleDeleteFila = (key) => {
    const fechaFila = data[key]?.[0];
    const newData = [...data];
    newData.splice(key, 1);
    updateDataAndSelects(newData, fechaFila);
  };

  const handleOpenConfirmationModalAll = () => {
    getListSalonByTipo(
      defaultTipoSalonSelectValue,
      0,
      dataCustom[0],
      true,
      false
    );
    handleChangeSalon(defaultSalonSelectValue, 0, dataCustom[0], true);
  };

  const handleOpenConfirmationModalIndividual = (index, row) => {
    if (tipoSalonesPost[index]?.delete === true) {
      const reverseSalon = {
        label: `${row[12]} - ${row[5]}`,
        value: row[12],
        name: row[5],
        capacidad: row[6],
        delete: false,
      };
      const reverseSalonTipo = {
        label: `${row[4]}`,
        value: null,
      };
      getListSalonByTipo(reverseSalonTipo, index, row, false, false);
      handleChangeSalon(reverseSalon, index, row);
    } else {
      getListSalonByTipo(defaultTipoSalonSelectValue, index, row, false, false);
      handleChangeSalon(defaultSalonSelectValue, index, row);
    }
  };

  return (
    <Grid>
      <Grid sx={12}>
        <Grid
          container
          spacing={2}
          style={{ padding: "10px 0px", alignItems: "center" }}
        >
          <Grid
            xs={1}
            item
            container
            style={{ justifyContent: "flex-end", marginLeft: "-2%" }}
          >
            <label>Campus:</label>
          </Grid>
          <Grid xs={2} item>
            <input className="filter-input" value={campusUser} disabled />
          </Grid>
          <Grid
            xs={1}
            item
            container
            style={{ justifyContent: "flex-end", marginLeft: "-2.8%" }}
          >
            Ciclo:
          </Grid>
          <Grid xs={1} item>
            <input
              className="filter-input"
              onChange={(e) => setValueCiclo(e.target.value)}
              value={valueCiclo}
            />
          </Grid>
          <Grid
            xs={1}
            item
            container
            style={{
              justifyContent: "flex-end",
              marginLeft: "-3%",
              marginRight: "-0.7%",
            }}
          >
            <label>Grupo:</label>
          </Grid>
          <Grid xs={1} item container style={{ marginLeft: "10px" }}>
            <input
              className="filter-input"
              value={grupoValue}
              onChange={handleGrupoValue}
            />
          </Grid>
          <Grid
            xs={1}
            item
            container
            style={{ justifyContent: "flex-end", marginLeft: "-1.2%" }}
          >
            <label>Materia:</label>
          </Grid>
          <Grid xs={4} item container style={{ zIndex: 99 }}>
            <Select
              className="select-modal-container input-tipo"
              classNamePrefix="select-modal"
              options={materiaOptions}
              styles={asyncSelectStyles}
              isLoading={selectMateriaIsLoading}
              onChange={(e) => handleMateria(e)}
              value={materia}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          style={{ padding: "10px 0px", alignItems: "center" }}
        >
          <Grid
            xs={1}
            item
            container
            style={{ justifyContent: "flex-end", marginLeft: "-2%" }}
          >
            <label>Escuela:</label>
          </Grid>
          <Grid xs={2} item style={{ zIndex: 99 }}>
            <input className="filter-input" value={escuela} disabled />
          </Grid>
          <Grid
            xs={1}
            item
            container
            style={{ justifyContent: "flex-end", marginLeft: "-1%" }}
          >
            <label>Dirección:</label>
          </Grid>
          <Grid xs={2} item>
            <input className="filter-input" value={direccion} disabled />
          </Grid>
          <Grid
            xs={2}
            item
            container
            justifyContent="flex-end"
            style={{ marginLeft: "-6%" }}
          >
            <label>Clave Profesor:</label>
          </Grid>
          <Grid xs={2} item style={{ zIndex: 90 }}>
            <input className="filter-input" value={claveProfesor} disabled />
          </Grid>
          <Grid xs={1} item container justifyContent="flex-end">
            <label>Asignado:</label>
          </Grid>
          <Grid xs={2} item>
            <input className="filter-input" value={asignado} disabled />
          </Grid>
        </Grid>
      </Grid>
      <hr class="rounded"></hr>
      <Typography>Salones Reservados</Typography>
      <table className="table_dias table_background">
        <tr>
          <th>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  background: data.length === 0 ? "gray" : "#ed8501",
                  display: "flex",
                  alignItems: "center",
                  padding: 2,
                  borderRadius: 5,
                  cursor: "pointer",
                }}
                onClick={() => handleOpenConfirmationModalAll()}
              >
                <Delete style={{ width: 20, height: 20, color: "white" }} />
              </div>
            </div>
          </th>
          <th style={{ width: "200px" }}>Acciones</th>
          <th style={{ width: "80px" }}>Fecha </th>
          <th style={{ width: "55px" }}>Dia</th>
          <th style={{ width: "155px" }}>Hora Inicio</th>
          <th style={{ width: "155px" }}>Hora Fin</th>
          <th>Salón Anterior</th>
          <th>Tipo Salón</th>
          <th>Salón</th>
          <th>Capacidad</th>
        </tr>
        {data.map((el, i) => {
          let horaFinalAnterior;
          let minutosFinalAnterior;
          let indexActual = el?.[11];

          if (indexActual === indexAnterior) {
            horaFinalAnterior = horasFinalesAnteriores[i - 1] || "";
            minutosFinalAnterior = minutosFinalesAnteriores[i - 1] || "";
          }

          indexAnterior = indexActual;
          return (
            <tr key={i}>
              <td>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    style={{
                      background: salonSelectValue[i]?.delete ? "green" : "red",
                      display: "flex",
                      alignItems: "center",
                      padding: 2,
                      borderRadius: 5,
                      cursor: "pointer",
                      width: 20,
                    }}
                    onClick={() => {
                      handleOpenConfirmationModalIndividual(i, el);
                    }}
                  >
                    <Delete style={{ width: 20, height: 20, color: "white" }} />
                  </div>
                </div>
              </td>
              <td>
                <EditButton onClick={() => handleAddFila(el, i)}>
                  Agregar
                </EditButton>
                <EditButton
                  onClick={() => handleDeleteFila(i)}
                  disabled={el?.[8] === "dissable"}
                >
                  Eliminar
                </EditButton>
              </td>
              <td>{el?.[0]}</td>
              <td>{el?.[1]}</td>
              <td>
                <Grid style={{ display: "flex" }}>
                  <input
                    className="filter-input"
                    type="number"
                    min={el?.[9].substring(0, 2)}
                    max={el?.[10].substring(0, 2)}
                    value={horaFinalAnterior || el?.[2].substring(0, 2)}
                    onChange={(e) => {
                      getListSalonByTipo("", i, el, false, false, true);
                      if (el?.[8] === "dissable") {
                        e.target.value = e.target.min;
                        handleHoraInicia(e.target.value, i, "t");
                        const nuevosHorasFinalesAnteriores = [
                          ...horasFinalesAnteriores,
                        ];
                        nuevosHorasFinalesAnteriores[i] = e.target.min;
                        setHorasFinalesAnteriores(nuevosHorasFinalesAnteriores);
                        enqueueSnackbar(`La hora inicio debe ser ${el?.[9]}`, {
                          variant: "error",
                          autoHideDuration: null,
                        });
                      } else {
                        handleHoraInicia(e.target.value, i, "i");
                        enqueueSnackbar(
                          "Debe cambiar la hora fin de la fila anterior",
                          { variant: "error", autoHideDuration: null }
                        );
                      }
                    }}
                  />

                  <input
                    className="filter-input"
                    style={{ marginLeft: "1%" }}
                    type="number"
                    min={el?.[9].substring(3, 5)}
                    max={30}
                    step={30}
                    value={minutosFinalAnterior || el?.[9].substring(3, 5)}
                    onChange={(e) => {
                      getListSalonByTipo("", i, el, false, false, true);
                      if (el?.[8] === "dissable") {
                        enqueueSnackbar(`La hora inicio debe ser ${el?.[9]}`, {
                          variant: "error",
                          autoHideDuration: null,
                        });
                      } else {
                        handleMinutosValue(e.target.value, i, "i");
                        enqueueSnackbar(
                          "Debe cambiar los minutos fin de la fila anterior",
                          { variant: "error", autoHideDuration: null }
                        );
                      }
                    }}
                  />
                </Grid>
              </td>
              <td>
                <Grid style={{ display: "flex" }}>
                  <input
                    className="filter-input"
                    type="number"
                    min={el?.[9].substring(0, 2)}
                    max={el?.[10].substring(0, 2)}
                    defaultValue={el?.[3].substring(0, 2)}
                    onFocus={() => {
                      setIndexAct(el?.[11]);
                      setIndexSig(data[i + 1]?.[11]);
                    }}
                    onChange={(e) => {
                      getListSalonByTipo("", i, el, false, false, true);
                      handleHoraInicia(e.target.value, i, "t");
                      if (indexAct === indexSig) {
                        handleHoraInicia(e.target.value, i + 1, "i");
                        const value = parseInt(e.target.value);
                        const nuevosHorasFinalesAnteriores = [
                          ...horasFinalesAnteriores,
                        ];
                        nuevosHorasFinalesAnteriores[i] = value;
                        setHorasFinalesAnteriores(nuevosHorasFinalesAnteriores);
                      }
                    }}
                    onBlur={(e) => {
                      const value = parseInt(e.target.value);
                      const minValue = parseInt(e.target.min);
                      const maxValue = parseInt(e.target.max);

                      if (
                        (value >= minValue &&
                          data[i]?.[11] !== data[i + 1]?.[11] &&
                          value < maxValue) ||
                        isNaN(value)
                      ) {
                        e.target.value = e.target.max;
                        handleHoraInicia(e.target.value, i, "t");
                        const value = parseInt(e.target.value);
                        const nuevosHorasFinalesAnteriores = [
                          ...horasFinalesAnteriores,
                        ];
                        nuevosHorasFinalesAnteriores[i] = value;
                        setHorasFinalesAnteriores(nuevosHorasFinalesAnteriores);
                        enqueueSnackbar(
                          `El ultimo bloque de la hora fin debe ser ${el?.[10]}`,
                          { variant: "error", autoHideDuration: null }
                        );
                      }

                      if (value < minValue) {
                        e.target.value = e.target.min;
                        handleHoraInicia(e.target.value, i, "t");
                        const value = parseInt(e.target.value);
                        const nuevosHorasFinalesAnteriores = [
                          ...horasFinalesAnteriores,
                        ];
                        nuevosHorasFinalesAnteriores[i] = value;
                        setHorasFinalesAnteriores(nuevosHorasFinalesAnteriores);
                        enqueueSnackbar(`El valor mínimo es ${minValue}`, {
                          variant: "error",
                          autoHideDuration: null,
                        });
                      } else if (value > maxValue) {
                        e.target.value = e.target.max;
                        handleHoraInicia(e.target.value, i, "t");
                        const value = parseInt(e.target.value);
                        const nuevosHorasFinalesAnteriores = [
                          ...horasFinalesAnteriores,
                        ];
                        nuevosHorasFinalesAnteriores[i] = value;
                        setHorasFinalesAnteriores(nuevosHorasFinalesAnteriores);
                        enqueueSnackbar(`El valor máximo es ${maxValue}`, {
                          variant: "error",
                          autoHideDuration: null,
                        });
                      } else {
                        handleHoraInicia(e.target.value, i, "t");
                        const value = parseInt(e.target.value);
                        const nuevosHorasFinalesAnteriores = [
                          ...horasFinalesAnteriores,
                        ];
                        nuevosHorasFinalesAnteriores[i] = value;
                        setHorasFinalesAnteriores(nuevosHorasFinalesAnteriores);
                      }
                      if (
                        horasFinalesAnteriores[i] === el?.[10].substring(0, 2)
                      )
                        setMaxValue(el?.[10].substring(3, 5));
                      else setMaxValue(30);
                    }}
                  />
                  <input
                    className="filter-input"
                    style={{ marginLeft: "1%" }}
                    type="number"
                    min={0}
                    max={maxValue}
                    step={30}
                    defaultValue={el?.[10].substring(3, 5)}
                    onFocus={() => {
                      setIndexAct(el?.[11]);
                      setIndexSig(data[i + 1]?.[11]);
                    }}
                    onChange={(e) => {
                      getListSalonByTipo("", i, el, false, false, true);
                      if (e.target.value === "00") return;

                      const value = parseInt(e.target.value);
                      handleMinutosValue(e.target.value, i, "t");
                      if (indexAct === indexSig) {
                        handleMinutosValue(e.target.value, i + 1, "i");
                        const nuevosMinutosFinalesAnteriores = [
                          ...minutosFinalesAnteriores,
                        ];
                        nuevosMinutosFinalesAnteriores[i] = value;
                        setMinutosFinalesAnteriores(
                          nuevosMinutosFinalesAnteriores
                        );
                      }
                    }}
                    onBlur={(e) => {
                      if (e.target.value === "00") return;

                      const value = parseInt(e.target.value);
                      if (
                        horasFinalesAnteriores[i] ===
                          el?.[10].substring(0, 2) &&
                        data[i]?.[11] !== data[i + 1]?.[11]
                      ) {
                        const value = parseInt(el?.[10].substring(3, 5));
                        e.target.value = value;
                        setMaxValue(el?.[10].substring(3, 5));
                        handleMinutosValue(el?.[10].substring(3, 5), i, "t");
                        const nuevosMinutosFinalesAnteriores = [
                          ...minutosFinalesAnteriores,
                        ];
                        nuevosMinutosFinalesAnteriores[i] = value;
                        setMinutosFinalesAnteriores(
                          nuevosMinutosFinalesAnteriores
                        );
                        enqueueSnackbar(
                          `El valor máximo de hora fin es ${el?.[10]}`,
                          { variant: "error", autoHideDuration: null }
                        );
                        return;
                      }

                      if (value === 0 || value === 30) {
                        handleMinutosValue(value, i, "t");
                        const nuevosMinutosFinalesAnteriores = [
                          ...minutosFinalesAnteriores,
                        ];
                        nuevosMinutosFinalesAnteriores[i] = value;
                        setMinutosFinalesAnteriores(
                          nuevosMinutosFinalesAnteriores
                        );
                      } else if (value < maxValue) {
                        e.target.value = e.target.max;
                        handleMinutosValue(e.target.value, i, "t");
                        const value = parseInt(e.target.value);
                        const nuevosMinutosFinalesAnteriores = [
                          ...minutosFinalesAnteriores,
                        ];
                        nuevosMinutosFinalesAnteriores[i] = value;
                        setMinutosFinalesAnteriores(
                          nuevosMinutosFinalesAnteriores
                        );
                        enqueueSnackbar(
                          `Solo se permiten bloquen de 30 minutos`,
                          { variant: "error", autoHideDuration: null }
                        );
                      } else if (value > maxValue) {
                        e.target.value = e.target.min;
                        handleMinutosValue(e.target.value, i, "t");
                        const value = parseInt(e.target.value);
                        const nuevosMinutosFinalesAnteriores = [
                          ...minutosFinalesAnteriores,
                        ];
                        nuevosMinutosFinalesAnteriores[i] = value;
                        setMinutosFinalesAnteriores(
                          nuevosMinutosFinalesAnteriores
                        );
                      }
                    }}
                  />
                </Grid>
              </td>
              <td>{`${el?.[4]} - ${el?.[5]}`}</td>
              <td className="bg_select">
                <Select
                  className="select-modal-container"
                  classNamePrefix="select-modal"
                  styles={selectUpsStyles}
                  options={tipoSalon}
                  onChange={(e) => getListSalonByTipo(e, i, el)}
                  menuPlacement="top"
                  value={tipoSalonSelectValue[i]}
                />
              </td>
              <td className="bg_select">
                <Select
                  className="select-modal-container"
                  classNamePrefix="select-modal"
                  styles={selectUpsStyles}
                  isDisabled={listSalon[i].length === 0}
                  options={listSalon[i]}
                  onChange={(e) => {
                    handleChangeSalon(e, i, el);
                  }}
                  menuPlacement="top"
                  value={salonSelectValue[i]}
                />
              </td>
              <td>{salonSelectValue[i]?.capacidad}</td>
            </tr>
          );
        })}
      </table>
      {loading && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress size={50} />
        </div>
      )}
      {!loading && (
        <Grid sx={12} style={{ marginTop: "1%", marginLeft: "-2.2%" }}>
          <Grid
            container
            spacing={2}
            style={{ padding: "10px 0px", alignItems: "center" }}
          >
            <Grid xs={1} item container justifyContent="flex-end">
              <label>Creado:</label>
            </Grid>
            <Grid xs={1} item style={{ padding: 2 }}>
              <input className="filter-input" value={creado} disabled />
            </Grid>
            <Grid xs={2} item style={{ padding: 2, marginLeft: "0.5%" }}>
              <input className="filter-input" value={creadoPor} disabled />
            </Grid>
            <Grid
              xs={1}
              item
              container
              justifyContent="flex-end"
              style={{ padding: 2, marginLeft: "5%" }}
            >
              <label>Modificado:</label>
            </Grid>
            <Grid xs={1} item style={{ padding: 2 }}>
              <input className="filter-input" value={modificado} disabled />
            </Grid>
            <Grid xs={2} item style={{ padding: 2, marginLeft: "0.5%" }}>
              <input className="filter-input" value={modificadoPor} disabled />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
